// hooks
import useAuth from '../hooks/useAuth';
// utils
import createAvatar from '../utils/createAvatar';
//
import Avatar from './Avatar';

// ----------------------------------------------------------------------

export default function MyAvatar({ ...other }) {
  const { user } = useAuth();

  return (
    <Avatar
      src={user?.imgUrl}
      alt={user?.nombre}
      color={user?.photoURL ? 'default' : createAvatar(user?.nombre).color}
      {...other}
    >
      {createAvatar(user?.apePaterno).name}
    </Avatar>
  );
}
